<style lang='less' scoped>
    .empty-data-box{ position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); display: flex; flex-direction: column; align-items: center;
        img{ display: inline-block; width: 105px; height: 160px; }
        span{ color: #9599ab; font-size: 14px; }
    }
</style>
<template>
    <div class="empty-data-box">
        <img class="empty-data-box-img" src="@/assets/images/no_data.png" alt="" />
        <span class="empty-data-box-text">暂无数据</span>
        <slot name="more" />
    </div>
</template>
<script lang='ts'>

</script>